import React, { createRef, forwardRef, useImperativeHandle } from 'react';
import Form from '@rjsf/material-ui';
import {
  generateWidgets,
  generateTemplates,
  rjsfValidator,
  transformErrors,
} from 'src/react-jsonschema-katal';
import { RJSFSchema, RJSFValidationError, UiSchema } from '@rjsf/utils';
import debounce from 'lodash/debounce';
export interface IViewPanel {
  key?: string;
  disabled: boolean;
  formState: any;
  coreSchema: RJSFSchema;
  uiSchema: UiSchema;
  onSubmit?: (data: any) => void; //on Submit Button Click Event. Will be called once all client side validation passes
  onClientSideError?: (errors: RJSFValidationError[]) => void; //on Submit Button Error Event
}

const ViewPanel = forwardRef((props: IViewPanel, ref) => {
  const formRef = createRef<any>();
  useImperativeHandle(ref, () => {
    return {
      //this function is exposed to the parent.
      //So that React JSON Submit method can be called on clicking of the modal
      formSubmit() {
        formRef.current.submit();
      },
    };
  });

  const caseSummaryUiSchema = {
    ...props.uiSchema,
    'ui:submitButtonOptions': {
      norender: true, //the default submit button should not render.
    },
  };

  const onSubmit = ({ formData }: any) => {
    props.onSubmit && props.onSubmit(formData);
  };

  /**
   * This will invoke when any client side error occurs on the form.
   * @param errors
   */
  const handleError = (errors: RJSFValidationError[]) => {
    props.onClientSideError && props.onClientSideError(errors);
  };

  return (
    <Form
      key={props.key}
      ref={formRef}
      disabled={props.disabled}
      widgets={generateWidgets()}
      formData={props.formState}
      schema={props.coreSchema}
      validator={rjsfValidator}
      omitExtraData //this property is required to remove the extra data not present in the schema.
      showErrorList={false} //to disable showing the error list on top.
      uiSchema={caseSummaryUiSchema}
      onSubmit={debounce(onSubmit, 200)}
      templates={generateTemplates()}
      onError={handleError}
      transformErrors={transformErrors}
    ></Form>
  );
});

export { ViewPanel };
